module.exports = __webpack_public_path__ + "static/media/IMG_2449.64ed6058.JPG";